/* eslint-disable import/extensions,import/no-unresolved,no-console */
// https://www.npmjs.com/package/@newrelic/browser-agent#new-relic-browser-agent
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { ClientConfig } from 'client/configuration';
import { requestContext } from 'client/utils/request-context/request-context';
import { featureFlags } from 'client/utils/feature-flags';

const consoleMethods = ['log', 'error', 'warn', 'info', 'debug', 'trace'];

export function initNewRelic() {
  const flags = featureFlags.get();
  if (!flags.newrelic) return;

  const config = ClientConfig.get('newrelic');
  const options = config.browserConfig;
  const appName = config.app_name;

  const originalConsole = {};

  // preserving the original console to prevent the new relic from rewriting the methods
  // https://github.com/newrelic/newrelic-browser-agent/blob/93f0fd0076e1e1fcc2b353d766a7a95c0f524e76/src/features/logging/instrument/index.js#L25
  consoleMethods.forEach(method => {
    originalConsole[method] = console[method];
  });

  const agent = new BrowserAgent(options);
  // expose the agent globally as fast as possible
  window.newrelic = agent;

  // restoring
  consoleMethods.forEach(method => {
    console[method] = originalConsole[method];
  });
  const loggerMetadata = requestContext.get('loggerMetadata');
  Object.entries(loggerMetadata).forEach(([key, value]) => {
    agent.setCustomAttribute(key, value);
  });
  // adding additional metadata not part of loggerMetadata (e.g. fluentd metadata)
  agent.setCustomAttribute('app_name', appName);

  if (flags.catchUnhandledRejection) {
    agent.setErrorHandler(function ErrorHandler() {
      // Return feature flag based condition. If True - skip error, false - proceed
      return flags.disableNewrelicJsErrors;
    });
  }
}
